import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import Cards from "../../components/cards/cards";
import actionBtn from "../../assets/images/actionbtn.png";
import { Button, Popover } from "antd";
import { MdEdit } from "react-icons/md";
import styles from "./style.module.css";
import AdminGrid from "../../components/adminGrid/adminGrid";
import FeedbackModal from "../../components/feedbackModal/feedbackModal";
import { AiOutlineSearch } from "react-icons/ai";
import {
  disputeOfferSlot,
  getOfferSlotsByDatePastAndUpcoming,
} from "../../services/auth";
import "./style.css";

function GeneralAdmin() {
  const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
  const [data, setData] = useState("");
  const [rowData, setRowData] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(true);
  const [disputedItems, setDisputedItems] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const date = new Date().toISOString().split("T")[0];
        const response = await getOfferSlotsByDatePastAndUpcoming(date);
        const apiDisputedItems = response.data.data.reduce((acc, item) => {
          if (item["offerSlots.status"] === "disputed") {
            acc[item["offerSlots.id"]] = true;
          }
          return acc;
        }, {});

        setDisputedItems(apiDisputedItems);
        setRowData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const date = new Date().toISOString().split("T")[0];
        const response = await getOfferSlotsByDatePastAndUpcoming(date);
        setRowData(response.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const feedbackModal = (data) => {
    setData(data);
    console.log("Disputed Feedback Data:", data); // Log the data to console
    setIsFeedbackModalVisible(true);
    setDisputedItems((prev) => ({
      ...prev,
      [data?.["offerSlots.id"]]: true,
    }));
  };

  const CustomButton = ({ onClick, label, url }) => (
    <button
      disabled={!url}
      className="btn btn-primary btn_contained btn-sm fs_12"
      onClick={onClick}
    >
      {label}
    </button>
  );

  const joinCellRenderer = ({ data }) => (
    <CustomButton
      url={data?.["offerSlots.startURL"]}
      label={data?.["offerSlots.startURL"] ? "Join" : "Not Ready"}
      onClick={() => {
        console.log("Join clicked", data?.["offerSlots.startURL"]);
        if (data?.["offerSlots.startURL"]) {
          window.open(data?.["offerSlots.startURL"], "_blank");
        }
      }}
    />
  );

  // Custom cell renderer for the Action column
  const actionCellRenderer = ({ data }) => (
    <Popover content={popoverContent(data)} trigger="hover">
      <img
        src={actionBtn}
        alt="Warning / Blocked"
        style={{ width: "30px", height: "17px", cursor: "pointer" }}
      />
    </Popover>
  );

  const popoverContent = (data) => (
    <div className="text-center">
      <Button
        className="btn btn-sm text-secondary fs_12 border-0"
        onClick={() => feedbackModal(data)} // Open feedback modal with specific data
      >
        <div className="d-flex justify-content-between">
          <div>
            <MdEdit className={`text-secondary ${styles.cicon}`} />
          </div>
          <div>Feedback</div>
        </div>
      </Button>
    </div>
  );
  const getRowHeight = (params) => {
    var Heights = [60, 60, 60, 60];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  const centerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  };

  const defaultColDef = {
    resizable: true,
  };

  const filterTextBox = () => {
    console.log("Clicked Filter");
  };

  const handleOnChange = (e) => {
    setInput(e.target.value);
    console.log("Value Changed !", e.target.value);
  };

  const columnDefs = [
    {
      headerName: "Teacher",
      field: "teacher.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["teacher.fullName"] || "",
    },
    {
      headerName: "Subject",
      field: "extraSubjects",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => {
        const subjects = params.data?.["extraSubjects"] || [];
        return subjects.length > 0
          ? subjects.map((subject) => subject.subjectName).join(", ")
          : "N/A";
      },
    },
    {
      headerName: "Student",
      field: "student.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["student.fullName"] || "",
    },
    // { headerName: "Level", field: "level", width: 100, cellStyle: centerStyle },
    {
      headerName: "Date",
      field: "offerSlots.date",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["offerSlots.date"] || "",
    },
    {
      headerName: "Start Time",
      field: "offerSlots.startTime",
      width: 120,
      filter: true,
      cellStyle: centerStyle,
      valueGetter: (params) => {
        const startTime = params.data?.["offerSlots.startTime"];
        if (!startTime) return "";

        // Parse the time and format it as "h:mm AM/PM"
        const [hour, minute] = startTime.split(":").map(Number);
        const date = new Date();
        date.setHours(hour, minute);

        return date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
      },
    },
    {
      headerName: "Join",
      field: "offerSlots.startURL",
      width: 130,
      cellStyle: centerStyle,
      cellRenderer: joinCellRenderer,
      valueGetter: (params) => params.data?.["offerSlots.startURL"] || "",
    },
    {
      headerName: "Action",
      field: "action",
      width: 130,
      cellStyle: centerStyle,
      cellRenderer: actionCellRenderer,
    },
  ];

  const rowDataFiltered = Array.isArray(rowData)
    ? rowData.filter((item) => {
        if (!input) return true;
        return Object.keys(item).some((key) => {
          if (typeof item[key] === "string") {
            const s1 = (item[key] || "").toLowerCase();
            const s2 = (input || "").toLowerCase();
            return s1.includes(s2);
          }
          return false;
        });
      })
    : [];

  return (
    <div id="adminMainPage">
      <Layout>
        <Cards liveSessionsCount={rowDataFiltered.length} />
        <div className="d-flex justify-content-between align-items-center">
          <h3 className="h3">Live Sessions</h3>
          <div className="">
            <form className="d-flex rounded" role="search">
              <div
                className={`d-flex rounded ${styles.searchBG_color} me-2 my-1 shadow-sm`}
              >
                <input
                  type="search"
                  id="filterTextBox"
                  onClick={filterTextBox}
                  onChange={handleOnChange}
                  className={`form-control ${styles.fee_input} border-0 rounded form_control_focus_box_shadow_none ${styles.searchBG_color}`}
                  placeholder={"Search..."}
                  value={input}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  style={{
                    color: "#000",
                    opacity: 1,
                    fontSize: "13px",
                    "::placeholder": {
                      color: "white",
                      fontSize: "12px",
                    },
                  }}
                />
                <AiOutlineSearch className={`${styles.searhIcon}`} />
              </div>
            </form>
          </div>
        </div>

        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "100vh" }}
          >
            <div>Loading ...</div>
          </div>
        ) : (
          <AdminGrid
            row={rowDataFiltered}
            cols={columnDefs}
            rowClass={"fs_12"}
            gridOptions={gridOptions}
            defaultColDef={defaultColDef}
            style={{ height: "100vh" }}
            pagination={true}
          />
        )}

        <FeedbackModal
          isModalVisible={isFeedbackModalVisible}
          setIsModalVisible={setIsFeedbackModalVisible}
          data={data}
        />
      </Layout>
    </div>
  );
}

export default GeneralAdmin;
